// assets/cupones-bancos-global.js

(function(){
  var widgets = [];
  
  function getCurrentSKU() {
    // PRIORITY 1: Get SKU from .product-sku__value (most reliable on variant change)
    var skuValue = document.querySelector('.product-sku__value');
    if (skuValue) {
      var sku = (skuValue.textContent || skuValue.innerText).trim();
      if (sku && sku.length > 0) {
        return sku;
      }
    }
    
    // PRIORITY 2: Get SKU from .sku-pdp display (fallback for older structure)
    var skuDisplay = document.querySelector('.sku-pdp');
    if (skuDisplay) {
      var skuText = skuDisplay.textContent || skuDisplay.innerText;
      var sku = skuText.replace(/SKU:\s*/i, '').trim();
      if (sku && sku.length > 0) {
        return sku;
      }
    }
    
    // PRIORITY 3: Try meta tag
    var metaVariant = document.querySelector('meta[property="product:retailer_item_id"]');
    if (metaVariant && metaVariant.content) {
      return metaVariant.content;
    }
    
    // PRIORITY 4: ShopifyAnalytics (may be stale on variant change)
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      var prod = window.ShopifyAnalytics.meta.product;
      if (prod.variants && prod.variants[0] && prod.variants[0].sku) {
        return prod.variants[0].sku;
      }
    }
    
    return null;
  }
  
  function registerWidget(id, validSkus) {
    var exists = false;
    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i].id === id) {
        widgets[i].skus = validSkus.split(',').map(function(s) { return s.trim(); });
        exists = true;
        break;
      }
    }
    if (!exists) {
      widgets.push({id: id, skus: validSkus.split(',').map(function(s) { return s.trim(); })});
    }
  }
  
  function checkAndToggle() {
    var sku = getCurrentSKU();
    if (!sku) {
      return;
    }
    
    widgets.forEach(function(widget) {
      var element = document.getElementById(widget.id);
      if (!element) {
        return;
      }
      
      var shouldShow = widget.skus.indexOf(sku) !== -1;
      var widgetContainer = element;
      var hideClass = 'cd-hide';
      
      if (widgetContainer.classList.contains('cupones-bancos-widget-bbva')) {
        hideClass = 'cbw-bbva-hide';
      } else if (widgetContainer.classList.contains('cupones-bancos-widget-powerpay')) {
        hideClass = 'cbw-powerpay-hide';
      } else if (widgetContainer.classList.contains('cupones-bancos-widget-interbank')) {
        hideClass = 'cbw-interbank-hide';
      }
      
      if (shouldShow) {
        widgetContainer.classList.remove(hideClass);
        widgetContainer.style.display = '';
      } else {
        widgetContainer.classList.add(hideClass);
        widgetContainer.style.display = 'none';
      }
    });
  }
  
  // Initialize on page load
  document.addEventListener('DOMContentLoaded', checkAndToggle);
  window.addEventListener('load', checkAndToggle);
  
  // Track URL changes for SPA-style navigation
  var currentUrl = location.href;
  var urlObserver = new MutationObserver(function() {
    if (location.href !== currentUrl) {
      currentUrl = location.href;
      setTimeout(function() {
        checkAndToggle();
      }, 500);
    }
  });
  
  // Start observing URL changes
  urlObserver.observe(document, { subtree: true, childList: true });
  
  window.CuponesBancos = {
    register: registerWidget,
    check: checkAndToggle
  };
})();